import React, { useEffect, useState } from "react";
import AdminLTE, {
  Content,
  Row,
  Col,
  Box,
  Button,
  SimpleTable,
  Pagination,
  Inputs,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";

import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const { Text } = Inputs;

function AsistenciasByGroup({ history, match }) {
  const dispatch = useDispatch();

  const modelAsistencias = useSelector((state) => state.getAsistenciasByGroup);

  const [asistencias, setAsistencias] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [documento, setDocumento] = useState("");
  const [total, setTotal] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const onChange = (dates) => {
    const [start, end] = dates;
   
    setStartDate(start);
    setEndDate(end);
  };

  useEffect(() => {
    const data = modelAsistencias?.data?.data;
    const error = modelAsistencias?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckGetAsistenciasByDategGroup.actions.clear());
    }
    if (data) {
      setAsistencias(data.data.items);
  
      let totalResults = 0;

      data.data.items.forEach((item) => {
      
        totalResults = totalResults + item.asistencias;
      });
     
      setTotal(totalResults);

      dispatch(controller.duckGetAsistenciasByDategGroup.actions.clear());
    }
  }, [modelAsistencias]);

  useEffect(() => {
    dispatch(controller.getAsistenciasByGroupThunk(match.params.organizacion));

  }, []);

  function handlePage(page) {
    setActivePage(page);
    setAsistencias([]);
    dispatch(
      controller.getAsistenciasByGroupThunk(match.params.organizacion, startDate, endDate)
    );
  }

  return (
    <Content
      title="Asistencias"
      subTitle="Asistencias"
      browserTitle="Asistencias"
      show={false}
    >
      <Row>
        <Col md="6" mdOffset="3">
          <Box title="Asistencias">
            <Col md="12" style={{ marginBottom: 30 }}>
              <Col md="3">
                <label>Fecha (dd/mm/yyyy)</label>
                <DatePicker
                  // dateFormat="dd/MM/yyyy"
                  // customInput={<input type="text" className="form-control" />}
                  selected={startDate}
                  onChange={onChange}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  // inline
                />
              </Col>

              <Col md="3">
                <div style={{ marginTop: 15 }}>
                  <Button
                    type="primary"
                    text="Filtrar"
                    onClick={() => handlePage(0)}
                  />
                </div>
              </Col>
            </Col>

            {asistencias && asistencias.length > 0 ? (
              <SimpleTable
                hover={true}
                data={asistencias.map((row, index) => {
                  return {
                    fecha: moment(row._id).format("DD-MM-YYYY"),
                    asistencias: row.asistencias,
                    conReserva: row.conReserva,
                    sinReserva: row.sinReserva,
                    detalles: (
                      <Button
                        type="primary"
                        text="Ver asistencias del dia"
                        onClick={() =>
                          history.push(
                            `/asistenciasByDate/${match.params.organizacion}/${row._id}`
                          )
                        }
                      />
                    ),
                  };
                })}
                columns={[
                  { title: "Fecha", data: "fecha" },
                  { title: "Asistencias", data: "asistencias" },
                  { title: "Con reserva", data: "conReserva" },
                  { title: "Sin reserva", data: "sinReserva" },
                  { title: "Detalles", data: "detalles" },
                ]}
              />
            ) : (
              <h4>No se han encontrado asistencias</h4>
            )}
            <div>
              <span>Total de asistencias: {total}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AsistenciasByGroup;
